import { NavLink } from 'react-router-dom'
import { navItemsFor } from '@/components/navigation/nav-items'
import { useUser } from '@/features/auth/useSession'
import { cn } from '@/lib/utils'
import { DsIconGlyph } from '@/ds'

export function BottomNav() {
  const user = useUser()
  if (!user) return null
  const items = navItemsFor(user.defaultProfile)
  return (
    <nav className="fixed inset-x-0 bottom-0 z-20 border-t bg-card pb-[env(safe-area-inset-bottom)] md:hidden" aria-label="Main">
      <ul className="flex h-16 items-stretch">
        {items.map(({ to, label, icon, end }) => (
          <li key={to} className="min-w-0 flex-1">
            <NavLink to={to} end={end} className={({ isActive }) => cn('flex h-full flex-col items-center justify-center gap-1 px-0.5 text-[11px] font-semibold leading-none outline-none focus-visible:ring-focus', isActive ? 'text-accent-foreground' : 'text-muted-foreground')}>
              {({ isActive }) => (
                <>
                  <span className={cn('flex h-7 w-12 items-center justify-center rounded-full transition-colors motion-fast', isActive && 'bg-accent')}>
                    <DsIconGlyph icon={icon} size={20} />
                  </span>
                  <span className="max-w-full truncate">{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
